import { render, staticRenderFns } from "./ProfileMultiView.vue?vue&type=template&id=08d78a18&"
import script from "./ProfileMultiView.vue?vue&type=script&lang=js&"
export * from "./ProfileMultiView.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMultiView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports